import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import { getRefillRequests } from "../../actions/prescriptionAction";
import NotePopup from "./NotePopup";
import PractitionerPrescriptionDetailPopup from "./PractitionerPrescriptionDetailPopup";
import { formatDate } from "../../utils/helper";
const RefillRequest = ({ ref }) => {
  const refillRequests = useSelector(
    (state) => state.prescription.refillRequests
  );
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [activePrescriptionId, setActivePrescriptionId] = useState(0);
  const [showPrescription, setShowPrescription] = useState(false);
  const [dateForDetail, setDateForDetail] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getRefillRequests());
  }, [dispatch]);

  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className="btn-orange btn-table "
            onClick={() => {
              setDateForDetail(formatDate(row.Created_Date));
              setActivePrescriptionId(row.ID);
              setShowPrescription(true);
            }}
          >
            View
          </button>
        </div>
      </>
    );
  };

  const columns = [
    {
      dataField: "Created_Date",
      text: "Date Created",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.Created_Date);
      },
    },
    {
      dataField: "Patient_Name",
      text: "Patient",
      sort: true,
    },
    {
      dataField: "feedback",
      text: "Note",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faFileAlt}
            size="3x"
            onClick={() => {
              setActiveItem({
                prescriptionId: row.ID,
                note: row.Note,
                date: row.Note_Date,
              });
              setShowNotePopup(true);
            }}
          />
        );
      },
    },

    {
      dataField: "action",
      text: "Action",
      formatter: patientAction,
    },
  ];

  return (
    <div ref={ref}>
      <h5 className="profile-title mb-1">Refill Request</h5>
      {showNotePopup && (
        <NotePopup
          closePopup={() => setShowNotePopup(false)}
          previousNote={activeItem}
        />
      )}
      {showPrescription && (
        <PractitionerPrescriptionDetailPopup
          closePopup={() => setShowPrescription(false)}
          prescriptionId={activePrescriptionId}
          isRefill={true}
          date={dateForDetail}
        />
      )}
      {refillRequests?.length > 0 ? (
        <BootstrapTable
          classes="react-bootstrap-table"
          keyField="ID"
          columns={columns}
          data={refillRequests}
          headerClasses="header-class"
        />
      ) : (
        <p className="page-desc">There are no Refill Requests at this time.</p>
      )}
    </div>
  );
};

export default RefillRequest;
